import { apiCallback } from 'api';

const definition = {
  service: 'content',
  endpoint: 'content/offers',
  query: {
    clientType: 'WEB_APP',
  },
  headers: {
    'wtr-uuid': '${uuid}',
  },
  verbs: ['put'],
  defaultVersion: 2,
};

export default {
  put: apiCallback(definition, 'put'),
};
